import { HttpClient } from '@angular/common/http';
import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-register-cmp',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
/* export class RegisterComponent implements OnInit, OnDestroy {
  test: Date = new Date();
  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('register-page');
    body.classList.add('off-canvas-sidebar');
  }
  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('register-page');
    body.classList.remove('off-canvas-sidebar');
  }
} */
export class RegisterComponent implements OnInit {
  @ViewChild('fileInput') fileInputRef: ElementRef;
  @ViewChild('fileInputTwo') fileInputRefTwo: ElementRef;
  @ViewChild('fileInputThree') fileInputRefThree: ElementRef;
  @ViewChild('fileInputFour') fileInputRefFour: ElementRef;
  @ViewChild('fileInputFive') fileInputRefFive: ElementRef;
  @ViewChild('fileInputSix') fileInputRefSix: ElementRef;
  url: string = 'users';
  form!: FormGroup;
  roles: Array<any> = [];
  identifications: Array<any> = [];
  indicatives: Array<any> = [];
  countries: Array<any> = [];
  backgrounds: Array<any> = [];
  files: any = [];
  upload = false;
  upload_two = false;
  apiUrl = environment.apiUrl;
  imagePreviews: { [key: string]: string } = {};
  showPassword = false;
  showPasswordTwo = false;
  step = 1;

  uploadStatus = {
    contract: false,
    nda: false,
    licensesMedical: false,
    insurance: false,
    licensesLeave: false,
  };

  isLoading = false;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private http: HttpClient
  ) {
    this.form = this.fb.group(
      {
        username: ['', [Validators.required]],
        title: ['', [Validators.required]],
        firstname: ['', [Validators.required]],
        lastname: ['', [Validators.required]],
        identification: ['', [Validators.required]],
        rut: ['', [Validators.required]],
        status: [false],
        password: ['', [Validators.required]],
        confirmPassword: ['', [Validators.required]],
        indicative: ['', [Validators.required]],
        phone: ['', [Validators.required]],
        img: ['', [Validators.required]],
        imgIdentification: ['', [Validators.required]],
        twoFAEnabled: [true],
        address: ['', [Validators.required]],
        apt: [''],
        city: ['', [Validators.required]],
        state: ['', [Validators.required]],
        country: ['', [Validators.required]],
        compliance: this.fb.group({
          contract: [''],
          nda: [''],
          //licenses: [''],
          licenses: this.fb.array([]),
          insurance: [''],
          startContract: ['', [Validators.required]],
          endContract: ['', [Validators.required]],
          verifiedBy: [''],
          background: [''],
          legalStatus: [''],
        }),
      },
      { validators: this.passwordMatchValidator() }
    );
  }

  ngOnInit(): void {
    this.indicatives = [
      '+1',
      '+57',
      '+52',
      '+55',
      '+54',
      '+56',
      '+58',
      '+34',
      '+44',
    ];

    this.identifications = ['DNI', 'Passport', 'International Driving Permit'];
    this.backgrounds = ['Yes', 'No', 'Under review'];
    this.cities();
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    this.createData();
  }

  createData(): void {
    this.isLoading = true;
    const dataForm = new FormData();

    /* Object.entries(this.form.value).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        dataForm.append(key, value as any);
      }
    }); */

    Object.entries(this.form.value).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (typeof value === 'object') {
          dataForm.append(key, JSON.stringify(value));
        } else {
          dataForm.append(key, value as any);
        }
      }
    });

    console.log('files', this.files);
    /* if (this.files?.length) {
      this.files.forEach((f) => dataForm.append('files', f));
    } */
    if (this.files?.length) {
      this.files.forEach((fileObj) => {
        dataForm.append('files', fileObj.file);
      });
    }
    console.log('files2', this.files);

    this.dataService
      .postData(`${this.url}/registerDashboard`, dataForm)
      .subscribe((response) => {
        console.log('response', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.upload = false;
          this.upload_two = false;
          delete this.imagePreviews;
          this.isLoading = false;
          this.router.navigateByUrl('/pages/login');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  selectFile() {
    this.fileInputRef.nativeElement.click();
  }

  selectFileTwo() {
    this.fileInputRefTwo.nativeElement.click();
  }

  selectFileThree(ref: string) {
    if (ref == 'fileInputThree') {
      this.fileInputRefThree.nativeElement.click();
    } else if (ref == 'fileInputFour') {
      this.fileInputRefFour.nativeElement.click();
    } else if (ref == 'fileInputFive') {
      this.fileInputRefFive.nativeElement.click();
    } else if (ref == 'fileInputSix') {
      this.fileInputRefSix.nativeElement.click();
    }
  }

  captureFile(event: any) {
    const original_file: File = event.target.files[0];

    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;

    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    let nameFile = file.name;
    console.log('nameFile:', nameFile);
    //this.files.push(file);
    this.upload = true;
    this.form.patchValue({
      img: nameFile,
    });
    this.updateFileList(file, 'img');
    this.previewFile(file, 'img'); // si quieres previsualización
  }

  captureFileTwo(event: any) {
    const original_file: File = event.target.files[0];

    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;

    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    let nameFile = file.name;
    console.log('nameFile:', nameFile);
    ///this.files.push(file);
    this.upload_two = true;
    this.form.patchValue({
      imgIdentification: nameFile,
    });
    this.updateFileList(file, 'imgIdentification');
    this.previewFile(file, 'imgIdentification');
  }

  captureFileThree(
    event: any,
    fieldKey: string,
    formKey: string,
    formGroupKey: string
  ) {
    const original_file: File = event.target.files[0];
    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;
    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    const nameFile = file.name;
    console.log('Archivo capturado:', nameFile);

    this.uploadStatus[fieldKey] = true;
    const group = this.form.get(formGroupKey);

    if (group instanceof FormGroup) {
      const control = group.get(formKey);

      if (control instanceof FormArray) {
        // Si es un array, agregamos un nuevo control con el nombre del archivo
        control.push(this.fb.control(nameFile));
      } else if (control instanceof FormControl) {
        // Si es un control normal, simplemente actualizamos su valor
        control.setValue(nameFile);
      } else {
        console.warn(`No se encontró el control ${formKey} en ${formGroupKey}`);
      }
    } else {
      console.warn(`No se encontró el grupo ${formGroupKey}`);
    }

    this.updateFileList(file, fieldKey);
  }

  updateFileList(file: File, fieldKey: string) {
    const index = this.files.findIndex((f) => f.fieldKey === fieldKey);
    if (index !== -1) {
      this.files[index] = { file, fieldKey }; // reemplazar si ya existe
    } else {
      this.files.push({ file, fieldKey }); // agregar si no existe
    }
  }

  previewFile(file: File, fieldKey: string) {
    const reader = new FileReader();
    reader.onload = () => {
      //this.previewUrl = reader.result as string; // Guardar el preview
      this.imagePreviews[fieldKey] = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  removeFile(fieldKey: string) {
    console.log('this.files', this.files);
    this.files = this.files.filter((f) => f.fieldKey !== fieldKey);
    delete this.imagePreviews[fieldKey];

    console.log('this.files', this.files);
    console.log('this.imagePreviews', this.imagePreviews);

    if (fieldKey === 'img') {
      this.upload = false;
      this.form.patchValue({
        img: '',
      });
    } else if (fieldKey === 'imgIdentification') {
      this.upload_two = false;
      this.form.patchValue({
        imgIdentification: '',
      });
    }
  }

  removeFileTwo(fieldKey: string, formKey: string, formGroupKey: string) {
    this.files = this.files.filter((f) => f.fieldKey !== fieldKey);
    //delete this.imagePreviews[fieldKey];

    this.uploadStatus[fieldKey] = false;

    (this.form.get([formGroupKey]) as FormGroup).patchValue({
      [formKey]: '',
    });
  }

  getProfileImgUrl(fieldKey: string): string {
    // Si hay un preview de nueva imagen, mostrarlo
    if (this.imagePreviews[fieldKey]) {
      return this.imagePreviews[fieldKey];
    }

    //console.log('fieldKey', fieldKey);
    //console.log('imagePreviews', this.imagePreviews);

    //./assets/img/faces/marc.jpg
    const img = this.form.get(fieldKey)?.value;
    return img ? `${this.apiUrl}/uploads/${img}` : '';
  }

  cities() {
    this.http
      .get('https://restcountries.com/v3.1/all?fields=name')
      .subscribe((data: any[]) => {
        this.countries = data;
        this.countries = data.map((el) => el.name.common);
        this.countries.sort((a, b) => a.localeCompare(b));

        console.log('countries', this.countries);

        // Establecer "United States" como valor predeterminado si existe
        const EEUU = this.countries.find(
          (name) => name.toLowerCase() === 'united states'
        );

        //console.log('EEUU',EEUU)
        /* if (EEUU) {
          this.data.country = EEUU;
        } */
      });
  }

  /* formatPhone() {
    const phoneNumber = (this.form.get('phone')?.value || '').replace(
      /[^\d]/g,
      ''
    );

    const phoneNumberLength = (this.form.get('phone')?.value || '').length;
    console.log('logitud');
    console.log(phoneNumberLength);
    if (phoneNumberLength <= 3) {
      //this.data.phone = phoneNumber.slice(0, 3);
      this.form.patchValue({
        phone: phoneNumber.slice(0, 3),
      });
    } else if (phoneNumberLength == 4) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 4);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 4),
      });
    } else if (phoneNumberLength == 5) {
      //this.data.phone = '(' + phoneNumber.slice(0, 3);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3),
      });
    } else if (phoneNumberLength == 6) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      //console.log(this.data.phone);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 7) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 8) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 9) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 10) {
      //this.data.phone = '(' + phoneNumber.slice(0, 3) +   ') ' + phoneNumber.slice(3, 6) + ' - ' + phoneNumber.slice(6, 10);
      this.form.patchValue({
        phone:
          '(' +
          phoneNumber.slice(0, 3) +
          ') ' +
          phoneNumber.slice(3, 6) +
          ' - ' +
          phoneNumber.slice(6, 10),
      });
    }
  } */

  formatPhone(event: Event) {
    const input = event.target as HTMLInputElement;

    let digits = input.value.replace(/\D/g, '');
    digits = digits.slice(0, 10);

    let formatted = '';
    if (digits.length <= 3) {
      formatted = digits;
    } else if (digits.length <= 6) {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    } else {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(
        3,
        6
      )} - ${digits.slice(6)}`;
    }

    this.form.get('phone')?.setValue(formatted, { emitEvent: false });
  }

  passwordMatchValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const password = group.get('password')?.value;
      const confirmPassword = group.get('confirmPassword')?.value;

      return password === confirmPassword ? null : { mismatch: true };
    };
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordVisibilityTwo() {
    this.showPasswordTwo = !this.showPasswordTwo;
  }

  changeStep(step: number) {
    this.step = step;
  }

  pru() {
    console.log('prueba formulario', this.form.value);
  }
}
